import { useRouteMatch } from "react-router-dom";

import { Box, Link } from "@seneca/senekit";

type Props = {
  to: any;
  label?: string;
  matchPath?: string;
  exact?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
};

export default function ActiveLink({
  to,
  label,
  matchPath,
  exact,
  children,
  onClick
}: Props) {
  const pathToMatch = matchPath ? matchPath : !!to.pathname ? to.pathname : to;

  const activeRoute = useRouteMatch(pathToMatch);

  return (
    <Box textDecoration={activeRoute ? "underline" : "none"}>
      <Link navLink to={to} tone="neutral" exact={exact} onClick={onClick}>
        {children}
        {label}
      </Link>
    </Box>
  );
}
